<template>
    <div class="wrap">
        <div class="container lnb">
            <div class="contents_wrap">
                <div class="contents no_height">
                    <div class="title">
                        {{ this.$route.meta.title }}
                        <div class="clear"></div>
                    </div>
                    <example-write-component :exampleType="'writeWord'"></example-write-component>
                </div>
                <div class="content_btn_wrap text_center">
                    <el-button type="primary" @click="save()">저장</el-button>
                    <el-button type="info" @click="$router.back()">취소</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ExampleWriteComponent from "@/components/example/ExampleWriteComponent";
import EventBus from "@/mixins/event-bus";

export default {
    name: "ExampleWordCreate",
    components: {ExampleWriteComponent},
    inject: [],
    provide() {
        return {};
    },
    props: {},
    data() {
        return {};
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        save() {
            EventBus.$emit('writeExample')
        },
    },
    watch: {}
}
</script>

<style scoped>

</style>